import { IReviewCardProps } from "@libs/cards/ReviewCard";
import dynamic from "next/dynamic";

const ReviewsQuotes = dynamic(
  async () => await import("@components/icons/ReviewsQuotes"),
  {
    ssr: false,
  }
);
const ReviewerContent = dynamic(
  async () => await import("@libs/cards/components/ReviewCard/ReviewerContent"),
  {
    ssr: false,
  }
);
const MobileReviewInnerCarousel = dynamic(
  async () => await import("@libs/cards/components/MobileReviewInnerCarousel"),
  { ssr: false }
);

const MobileReviewCard = ({
  review,
  headshot,
  reviewer,
  country,
  date,
  images,
}: IReviewCardProps): JSX.Element => {
  return (
    <div className="flex w-full flex-col">
      <div className="z-[1] mx-auto mb-9">
        <ReviewsQuotes />
      </div>
      <div className="relative">
        {review}
        <ReviewerContent
          headshot={headshot}
          reviewer={reviewer}
          country={country}
          date={date}
        />
        {images?.length && (
          <div className="mt-6">
            <MobileReviewInnerCarousel images={images} reviewer={reviewer} />
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileReviewCard;
